(function () {
  // #lc-options が存在するページでのみ処理を実行
  let isInitialized = false;

  // 名入れfieldsetかどうか
  function isNamePrintFieldset(fs) {
    const legendText = fs?.querySelector('.variant-picker__option-info legend')?.textContent?.trim() ?? '';
    return legendText === '名入れ:';
  }

  // 同一商品セクション内を優先して customily を取得（なければ全体から）
  function getCustomilyBox(fromEl) {
    return (
      fromEl.closest('section, form, .product, .product__info-container')?.querySelector('#lc-options') ||
      document.querySelector('#lc-options')
    );
  }

  // 名入れ文字 input を取得（近場優先）
  function getNameInput(fromEl) {
    const sel = 'input[name="properties[名入れ文字]"]';
    return (
      fromEl.closest('section, form, .product, .product__info-container')?.querySelector(sel) ||
      document.querySelector(sel)
    );
  }

  function getFontInput(fromEl) {
  const sel = 'input[name="properties[フォント]"]';
  return (
    fromEl.closest('section, form, .product, .product__info-container')?.querySelector(sel) ||
    document.querySelector(sel)
  );
}



  // カート追加ボタンを取得
  function getSubmitButtons() {
    return document.querySelectorAll('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] input[type="submit"]');
  }

  // バリデーション状態をチェック
  function validateNamePrintInputs() {
    const isNone = isCurrentlyNamePrintNone();

    // 「名入れなし」の場合は常にバリデーションOK
    if (isNone) {
      return { valid: true };
    }

    // 「あり」の場合はチェック
    const nameInput = getNameInput(document.body);


    const nameValue = nameInput?.value?.trim() || '';

    // 名入れ文字が空
    if (nameValue.length === 0) {
      return { valid: false, message: '名入れ文字を入力してください', focusElement: nameInput };
    }


    return { valid: true };
  }

  // ボタンの無効状態を更新（視覚的にのみ）
  function updateSubmitButtonState() {
    const validation = validateNamePrintInputs();
    const buttons = getSubmitButtons();

    buttons.forEach(button => {
      if (validation.valid) {
        button.removeAttribute('aria-disabled');
        button.style.opacity = '';
        button.style.cursor = '';
        button.style.pointerEvents = '';
      } else {
        button.setAttribute('aria-disabled', 'true');
        button.style.opacity = '0.5';
        button.style.cursor = 'not-allowed';
        // pointer-eventsは設定しない（クリックイベントを受け取るため）
      }
    });
  }

  function applyStateByLabelText(contextEl, labelText) {
  const box = getCustomilyBox(contextEl);
  const nameInput = getNameInput(contextEl);
  const fontInput = getFontInput(contextEl);

  if (!box) return;

  if (labelText === '名入れなし' || labelText === 'なし') {
    box.style.display = 'none';

    if (nameInput) {
      nameInput.value = '';
      nameInput.dispatchEvent(new Event('input', { bubbles: true }));
      nameInput.dispatchEvent(new Event('change', { bubbles: true }));
      nameInput.blur?.();
    }

    if (fontInput) {
      fontInput.disabled = true;
    }
  } else {
    box.style.display = '';

    if (fontInput) {
      fontInput.disabled = false;
      fontInput.value = '筆記体';
    }
  }

  requestAnimationFrame(() => {
    updateSubmitButtonState();
  });
}

  // ラベルクリックで判定・反映
  function handleClick(e) {
    const label = e.target.closest('label.block-swatch');
    if (!label) return;

    const fieldset = label.closest('fieldset.variant-picker__option');
    if (!fieldset || !isNamePrintFieldset(fieldset)) return;

    const labelText = label.textContent.trim();

    requestAnimationFrame(() => {
      applyStateByLabelText(fieldset, labelText);
    });
  }

  // 現在の名入れ状態が「なし」かどうかをチェック
  function isCurrentlyNamePrintNone() {
    const fieldsets = document.querySelectorAll('fieldset.variant-picker__option');
    for (const fs of fieldsets) {
      if (!isNamePrintFieldset(fs)) continue;
      const checked = fs.querySelector('input[type="radio"]:checked');
      if (!checked) continue;
      const checkedLabel = fs.querySelector(`label[for="${checked.id}"]`);
      const text = checkedLabel ? checkedLabel.textContent.trim() : '';
      return text === '名入れなし' || text === 'なし';
    }
    return false;
  }

function updateCustomilyVisibility() {
  const boxes = document.querySelectorAll('#lc-options');
  const isNone = isCurrentlyNamePrintNone();

  boxes.forEach(box => {
    box.style.display = isNone ? 'none' : '';
  });

  document.querySelectorAll('input[name="properties[フォント]"]').forEach(input => {
    input.disabled = isNone;
    if (!isNone) {
      input.value = '筆記体';
    }
  });
}

  // MutationObserver で #lc-options の出現と変更を監視
  let observer = null;

  // ボタンクリック時のバリデーション
  function handleButtonClick(e) {
    const button = e.target.closest('button[type="submit"], input[type="submit"]');
    if (!button) return;

    const form = button.closest('form[action*="/cart/add"]');
    if (!form) return;

    // バリデーション結果を確認
    const validation = validateNamePrintInputs();

    if (!validation.valid) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      alert(validation.message);
      validation.focusElement?.focus();
      return false;
    }
  }

  // フォーム送信時のバリデーション（念のための二重チェック）
  function handleFormSubmit(e) {
    const form = e.target;

    // カート追加フォーム以外は無視
    if (!form.matches('form[action*="/cart/add"]')) return;

    // バリデーション結果を確認
    const validation = validateNamePrintInputs();

    if (!validation.valid) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      alert(validation.message);
      validation.focusElement?.focus();
      return false;
    }
  }

  // 入力変更時のハンドラ
  function handleInputChange() {
    updateSubmitButtonState();
  }

  // 処理を初期化
  function initialize() {
    if (isInitialized) return;
    isInitialized = true;

    // 名入れラベルクリックイベント登録
    document.addEventListener('click', handleClick, true);

    // ボタンクリックイベント登録（バリデーション用）
    document.addEventListener('click', handleButtonClick, true);

    // フォーム送信イベント登録（念のための二重チェック）
    document.addEventListener('submit', handleFormSubmit, true);

    // 入力変更イベント登録（名入れ文字とフォント）
    document.addEventListener('input', function(e) {
      const target = e.target;
      if (target.name === 'properties[名入れ文字]' || target.name === 'properties[フォント]') {
        handleInputChange();
      }
    }, true);

    document.addEventListener('change', function(e) {
      const target = e.target;
      if (target.name === 'properties[名入れ文字]' || target.name === 'properties[フォント]') {
        handleInputChange();
      }
    }, true);

    // MutationObserver 開始
    observer = new MutationObserver(() => {
      updateCustomilyVisibility();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style']
    });

    // 初期状態を反映
    document.querySelectorAll('fieldset.variant-picker__option').forEach(fs => {
      if (!isNamePrintFieldset(fs)) return;
      const checked = fs.querySelector('input[type="radio"]:checked');
      if (!checked) return;
      const checkedLabel = fs.querySelector(`label[for="${checked.id}"]`);
      const text = checkedLabel ? checkedLabel.textContent.trim() : '';
      applyStateByLabelText(fs, text);
    });

    // 初回チェック
    updateCustomilyVisibility();
    updateSubmitButtonState();
  }

  // #lc-options の存在を確認して初期化
  function checkAndInitialize() {
    const lcOptions = document.querySelector('#lc-options');
    if (lcOptions) {
      initialize();
      return true;
    }
    return false;
  }

  // ページ読み込み時に確認
  document.addEventListener('DOMContentLoaded', function () {
    // 即座に確認
    if (checkAndInitialize()) return;

    // 見つからなければ少し待ってから確認（遅延ロード対策）
    const checkObserver = new MutationObserver(() => {
      if (checkAndInitialize()) {
        checkObserver.disconnect();
      }
    });

    checkObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    // 3秒後にタイムアウト
    setTimeout(() => {
      checkObserver.disconnect();
    }, 3000);
  });
})();